import { useState, useEffect } from 'react';

// Stile Ricardo: nasconde quando scorri giù, ricompare appena risali.
export function useHideOnScroll(enabled) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!enabled) { setHidden(false); return undefined; }
    let lastY = window.scrollY;
    let ticking = false;
    const update = () => {
      const y = window.scrollY;
      if (y < 80) setHidden(false);
      else if (y > lastY + 8) setHidden(true);
      else if (y < lastY - 8) setHidden(false);
      if (Math.abs(y - lastY) > 8 || y < 80) lastY = y;
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [enabled]);

  return hidden;
}
